<div class="toggle-switch">
  <label class="switch">
    <input type="checkbox" (change)="toggleView($event)" [checked]="isMapView" />
    <span class="slider">
      <span class="label left">Liste</span>
      <span class="label right">Carte</span>
      <span class="knob"></span>
    </span>
  </label>
</div>
